const initialState = {
  registeruserInfo: {},
}

const registeruserInfo = (state = initialState, action = {}) => {
  if (action.type === 'REGISTERUSERINFO') {
    return { ...state, registeruserInfo: action.payload }
  } else {
    return state
  }
}

export default registeruserInfo
